import { Printer } from "lucide-react";
import { API_BASE, SA_ORG_KEY } from "@/lib/api";

/* Opens the next-24-hour run sheet ("The Morning Print") as a PDF in a new tab. */
export default function PrintScheduleButton({ plantId, hours = 24, className = "" }) {
  const org = localStorage.getItem(SA_ORG_KEY);
  const href = `${API_BASE}/dispatch/schedule.pdf?hours=${hours}${plantId ? `&plant_id=${plantId}` : ""}${org ? `&org_id_override=${org}` : ""}`;
  return (
    <a href={href} target="_blank" rel="noreferrer" data-testid="print-schedule-btn"
      title="Print the next 24 hours as a PDF run sheet (jobs, sites, mixes, trucks, drivers, phones, notes)"
      className={`mono text-[10px] uppercase tracking-widest px-2 py-1 border border-industrial text-ink hover:border-primary-orange hover:text-primary-orange inline-flex items-center gap-1 ${className}`}>
      <Printer className="w-3 h-3" /> Print Schedule
    </a>
  );
}
